module.exports = __webpack_public_path__ + "static/media/2-5.2d9815eb.png";